import { render, staticRenderFns } from "./ErrorGeneric.vue?vue&type=template&id=5a632572"
import script from "./ErrorGeneric.vue?vue&type=script&lang=js"
export * from "./ErrorGeneric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports